
import React from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

interface MobileDocumentationTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const MobileDocumentationTabs = ({ activeTab, setActiveTab }: MobileDocumentationTabsProps) => {
  const tabs = [
    { value: "getting-started", label: "Getting Started" },
    { value: "leads", label: "Leads" },
    { value: "companies", label: "Companies" },
    { value: "users", label: "Users" },
    { value: "campaign-planner", label: "Campaign Planner" },
    { value: "changelog", label: "Changelog" },
  ];

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle documentation menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left">
        <SheetHeader>
          <SheetTitle>Documentation</SheetTitle>
        </SheetHeader>
        <div className="mt-4 space-y-2">
          {tabs.map((tab) => (
            <Button
              key={tab.value}
              variant={activeTab === tab.value ? "default" : "ghost"}
              className="w-full justify-start"
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.label}
            </Button>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileDocumentationTabs;
